export interface DefaultFiltersTranslation {

  search: string;
  manage_options: string;

  add_filters: string;
  remove: string;
  remove_all: string;
  done: string;

  sequence: string;
  required: string;
  no_default_value: string;
  use_default_value: string;

  filters_not_supported: string;

  filters_my_location: string;
  filters_my_unit: string;
  filters_person: string;

  filters_date_range_date_fixed_period: string;
  filters_date_range_date_interval: string;
  filters_date_range_from: string;
  filters_date_range_to: string;

  must_be_filled_out: string;
  at_least_one_must_be_filled_out: string;
}

export interface DefaultFiltersEndpoints {
  filterFields: string;
  filterDomains: string;
  filterMetadata: string;
  codeOptionsFor: (id: number) => string;
  categoryOptionsFor: (id: number) => string;
  periodPredefOptions: string;
  dbFunction: string;
}

export enum DefaultFilterType {
  FlatList = 1,
  Hierarchy = 2,
  Date = 6,
  Checkbox = 8,
  Unit = 11,
  Location = 12,
  Person = 13,
  FlatListSequential = 14,
  FlatListWithCategories = 15,
  HierarchyWithCategories = 16,
  FlatListSequentialWithCategories = 17,
  HierarchySequentialWithCategories = 18
}

export const listWithCategories = [
  DefaultFilterType.FlatListWithCategories,
  DefaultFilterType.HierarchyWithCategories,
  DefaultFilterType.FlatListSequentialWithCategories,
  DefaultFilterType.HierarchySequentialWithCategories
];
